__turbopack_context__.v({
  "className": "QDSjwq_className",
  "variable": "QDSjwq_variable",
});
